
import React from 'react';
import PropTypes from 'prop-types';

import {
    Button,
    Card,
    CardHeader,
    CardBody,
    CardFooter,
    Row,
    Col
} from 'reactstrap';

import {
    DeviceTable
} from 'components/blocks'

import {
    TablePagination,
    PagingButton
} from 'components/elements';


const Device = ({
    type,
    device,
    onListRefresh,
    onPagingChange,
    onDevActionClicked,
    onCallerIdUpdated,
    updateDeviceCallerId
}) => {

    const { pagination, ..._device } = device;
    const { currentPage, itemPerPage } = pagination

    let indexEnd = currentPage * itemPerPage;
    let indexStart = indexEnd - itemPerPage
    if (indexEnd > _device.list.length) {
        indexEnd = _device.list.length
    }
    let itemsList = _device.list.slice(indexStart, indexEnd)
    _device.list = itemsList;

    let title = ''
    if (type === 'pendings') {
        title = 'Waiting for approval'
    }
    if (type === 'actives') {
        title = 'Activated'
    }
    if (type === 'inactives') {
        title = 'Deactivated'
    }
    return (
        <React.Fragment>
            <div className="animated fadeIn">
                <Card style={{ backgroundColor: "#f7f7f7" }}>
                    <CardHeader className="bg-dark">
                        <Row className="w-100 ml-0">
                            <Col xs="12" sm="6" className="my-auto pl-0 text-left h3 font-weight-normal">
                                Devices / <strong>{title}</strong>
                            </Col>
                            <Col xs="12" sm="6" className="text-right mt-2 mt-sm-0 pr-0">
                                <Button size="sm" color='dark' className="filter-toggler px-4" onClick={onListRefresh}>
                                    Refresh List <i className="icon-refresh"></i>
                                </Button>
                            </Col>
                        </Row>
                    </CardHeader>
                    <CardBody className="p-0" style={{ overflow: 'auto' }}>
                        <DeviceTable
                            type={type}
                            indexStart={indexStart}
                            items={_device}
                            onDevActionClicked={onDevActionClicked}
                            updateDeviceCallerId={updateDeviceCallerId}
                            onCallerIdUpdated={onCallerIdUpdated}
                        />
                    </CardBody>
                    <CardFooter>
                        <Row>
                            <Col xs="12" sm="2" className="text-center text-sm-left mt-2 mt-sm-0 order-2 order-sm-1">
                                <PagingButton
                                    numberOfRows={pagination.itemPerPage}
                                    onSelected={(noOfRows) => {
                                        let pCount = Math.ceil(pagination.total / noOfRows);
                                        if (pCount < 1) pCount = 1;
                                        let _pagination = {
                                            ...pagination,
                                            itemPerPage: noOfRows,
                                            pageCount: pCount
                                        }
                                        onPagingChange(_pagination);
                                    }}
                                />
                            </Col>
                            <Col xs="12" sm="10" className="text-center text-sm-right order-1 order-sm-2">
                                <TablePagination
                                    pagination={pagination}
                                    sheetsPerPage={5}
                                    onSelected={(page) => {
                                        let _pagination = {
                                            ...pagination,
                                            currentPage: page
                                        }
                                        onPagingChange(_pagination);
                                    }}
                                />
                            </Col>
                        </Row>
                    </CardFooter>
                </Card>
            </div>
        </React.Fragment >
    )
};

Device.propTypes = {
    type: PropTypes.string,
    device: PropTypes.object,
    onListRefresh: PropTypes.func,
    onPagingChange: PropTypes.func,
    onDevActionClicked: PropTypes.func,
    onCallerIdUpdated: PropTypes.func,
    updateDeviceCallerId: PropTypes.func,
};

export default Device;


// WEBPACK FOOTER //
// ./src/components/sections/Device/Device.js